"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GENERIC_CLIENT_ERROR = exports.GENERIC_TRACK_ERROR = exports.GENERIC_TREATMENTS_ERROR = exports.DEFAULT_GET_TREATMENTS_ROUTE = exports.DEFAULT_TRACK_ROUTE = void 0;
exports.DEFAULT_TRACK_ROUTE = "/api/split/track";
exports.DEFAULT_GET_TREATMENTS_ROUTE = "/api/split/get-treatments";
exports.GENERIC_TREATMENTS_ERROR = "Could not return correct treatments";
exports.GENERIC_TRACK_ERROR = "Could not send track event";
exports.GENERIC_CLIENT_ERROR = "Could not initiate client";
